// filename: src/services/usage/usageApi.ts

import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../config';
import deviceInfoAxios from '../../../utils/axios/deviceInfo.axios';

export type AiQuotaResponse = {
    window: 'rolling_30_days';
    hotelSub: string;
    wordsUsed: number;
    limitWords: number;
    percentUsed: number;
    remainingWords: number;
    isExceeded: boolean;
};

export type KbQuotaResponse = {
    hotelSub: string;
    usedPages: number;
    limitPages: number;
    remainingPages: number;
    percentUsed: number;
    isExceeded: boolean;
};

export const UsageService = {
    getAiQuota(): Promise<
        AxiosResponse<{ success?: boolean; data: AiQuotaResponse }>
    > {
        return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/ai-usage/quota`);
    },

    getKbQuota(): Promise<
        AxiosResponse<{ ok?: boolean; data: KbQuotaResponse }>
    > {
        return deviceInfoAxios.get(
            `${DEVICE_INFO_API_URL}/knowledge-base/quota`,
        );
    },
};
